import React from 'react';
import {
  Box,
  Card,
  Chip,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles,
  IconButton,
  Tooltip,
  TextField,
  Checkbox,
  Button
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import EditIcon from '@material-ui/icons/Edit';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: '#f5f6fa',
    color: '#45485E',
    fontWeight: 700,
    fontSize: 13,
    whiteSpace: 'nowrap',
    borderBottom: '2px solid #e0e3ef'
  },
  body: {
    fontSize: 13,
    whiteSpace: 'nowrap',
    color: '#333'
  },
  root: { padding: '10px 16px' }
}))(TableCell);

const OrdersTable = ({
  paginated,
  page,
  PAGE_SIZE,
  classes,
  isAdmin,
  isAccountant,
  isSale,
  formatMoney,
  formatInputMoney,
  getPaymentStyle,
  STATUS_CONFIG,
  isScrolled,
  isDown,
  onMouseDown,
  onMouseLeave,
  onMouseUp,
  onMouseMove,
  handleScroll,
  scrollContainerRef,
  localExtraFees,
  setLocalExtraFees,
  handleSaveExtraFee,
  localTrackingUrls,
  setLocalTrackingUrls,
  handleSaveTrackingUrl,
  handleDeliveredToggle,
  setEditingOrder,
  setEditingDevices,
  setOrderForImage,
  setOpenImageModal,
  setSelectedGallery,
  handleMenuOpen,
  handleCompleteOrder,
  listDeviceType,
  total,
  totalAmountSum,
  totalPaidSum,
  setPage
}) => {
  return (
    <Card className={classes.tableCard}>
      <Box
        ref={scrollContainerRef}
        onMouseDown={onMouseDown}
        onMouseLeave={onMouseLeave}
        onMouseUp={onMouseUp}
        onMouseMove={onMouseMove}
        onScroll={handleScroll}
        style={{
          cursor: isDown ? 'grabbing' : 'grab',
          overflowX: 'auto',
          overflowY: 'hidden',
          userSelect: isDown ? 'none' : 'auto',
          width: '100%'
        }}
      >
        <Table
          style={{
            borderCollapse: 'separate',
            borderSpacing: 0,
            minWidth: 1500
          }}
        >
          <TableHead>
            <TableRow>
              <StyledTableCell
                className={classes.stickyHeader}
                style={{ left: 0, width: 40, minWidth: 40 }}
              >
                #
              </StyledTableCell>
              <StyledTableCell
                className={classes.stickyHeader}
                style={{ left: 40, width: 80, minWidth: 80 }}
              >
                Thời gian
              </StyledTableCell>
              <StyledTableCell
                className={classes.stickyHeader}
                style={{ left: 120, width: 120, minWidth: 120 }}
              >
                Nhân viên Sale
              </StyledTableCell>
              <StyledTableCell
                className={classes.stickyHeader}
                style={{
                  left: 240,
                  width: 190,
                  minWidth: 190,
                  borderRight: isScrolled
                    ? '1px solid rgba(0,0,0,0.8)'
                    : 'none',
                  boxShadow: isScrolled
                    ? '6px 0 10px rgba(0,0,0,0.15)'
                    : 'none',
                  transition: 'border-right 0.2s, box-shadow 0.2s'
                }}
              >
                <span style={{ color: '#3f51b5' }}>Đại lý</span>/Khách lẻ
              </StyledTableCell>
              <StyledTableCell style={{ minWidth: 220 }}>Địa chỉ</StyledTableCell>
              <StyledTableCell style={{ minWidth: 150 }}>Ghi chú</StyledTableCell>
              <StyledTableCell>Chi tiết thiết bị</StyledTableCell>
              <StyledTableCell>Serial</StyledTableCell>
              <StyledTableCell>Sim</StyledTableCell>
              <StyledTableCell>PT kích hoạt</StyledTableCell>
              <StyledTableCell>Phân loại đơn</StyledTableCell>
              <StyledTableCell>HT lắp đặt</StyledTableCell>
              <StyledTableCell align="center">Tải ảnh</StyledTableCell>
              <StyledTableCell>Ảnh lắp đặt</StyledTableCell>
              <StyledTableCell>Tiền thiết bị</StyledTableCell>
              <StyledTableCell>Phí ship</StyledTableCell>
              <StyledTableCell>Tổng tiền</StyledTableCell>
              <StyledTableCell>Hình thức TT</StyledTableCell>
              <StyledTableCell>Link vận đơn</StyledTableCell>
              <StyledTableCell>Đã giao hàng</StyledTableCell>
              <StyledTableCell align="center">Hoàn thành</StyledTableCell>
              <StyledTableCell>Trạng thái</StyledTableCell>
              <StyledTableCell align="center">Thao tác</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginated.length > 0 ? (
              paginated.map((order, idx) => {
                const cfg = STATUS_CONFIG[order.status] || STATUS_CONFIG[0];
                return (
                  <TableRow hover key={order.id} className={classes.tableRow}>
                    <StyledTableCell
                      className={classes.stickyCol}
                      style={{
                        left: 0,
                        color: '#888',
                        fontSize: 12,
                        width: 40,
                        minWidth: 40
                      }}
                    >
                      {(page - 1) * PAGE_SIZE + idx + 1}
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.stickyCol}
                      style={{ left: 40, width: 80, minWidth: 80 }}
                    >
                      <Box display="flex" flexDirection="column">
                        <Typography
                          variant="body2"
                          style={{
                            fontSize: 13,
                            color: cfg.color || '#666',
                            fontWeight: 600
                          }}
                        >
                          {order.created_at || order.createdAt
                            ? (() => {
                                const d = new Date(
                                  order.created_at || order.createdAt
                                );
                                return !isNaN(d.getTime())
                                  ? `${String(d.getDate()).padStart(
                                      2,
                                      '0'
                                    )}/${String(d.getMonth() + 1).padStart(
                                      2,
                                      '0'
                                    )}/${d.getFullYear()}`
                                  : 'N/A';
                              })()
                            : 'N/A'}
                        </Typography>
                        <Typography
                          variant="body2"
                          style={{ fontSize: 13, color: cfg.color || '#888' }}
                        >
                          {order.created_at || order.createdAt
                            ? (() => {
                                const d = new Date(
                                  order.created_at || order.createdAt
                                );
                                return !isNaN(d.getTime())
                                  ? `${String(d.getHours()).padStart(
                                      2,
                                      '0'
                                    )}:${String(d.getMinutes()).padStart(
                                      2,
                                      '0'
                                    )}`
                                  : '';
                              })()
                            : ''}
                        </Typography>
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.stickyCol}
                      style={{ left: 120, width: 120, minWidth: 120 }}
                    >
                      <Box display="flex" flexDirection="column">
                        <Typography
                          variant="body2"
                          style={{
                            fontSize: 13,
                            fontWeight: 600,
                            color: '#3f51b5'
                          }}
                        >
                          {order.sale?.full_name ||
                            order.user?.username ||
                            (
                              order.sale_name ||
                              order.saleName ||
                              'Hệ thống'
                            )
                              .split('(')[0]
                              .trim()}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          style={{ fontSize: 13, color: '#888' }}
                        >
                          {order.sale?.role_id
                            ? order.sale.role_id === 2
                              ? 'Sale'
                              : order.sale.role_id === 1
                              ? 'Quản trị'
                              : order.sale.role_id === 3
                              ? 'Kế toán'
                              : `Role ${order.sale.role_id}`
                            : order.user?.role
                            ? order.user.role === 'SALE'
                              ? 'Sale'
                              : order.user.role === 'ACCOUNTANT'
                              ? 'Kế toán'
                              : order.user.role === 'ADMIN'
                              ? 'Quản trị'
                              : order.user.role
                            : (order.sale_name || '').includes('(')
                            ? (order.sale_name || '')
                                .split('(')[1]
                                .replace(')', '')
                            : (order.sale_name || order.saleName) ===
                                'Hệ thống' ||
                              !(order.sale_name || order.saleName)
                            ? 'Hệ thống'
                            : 'Sale'}
                        </Typography>
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.stickyCol}
                      style={{
                        left: 240,
                        width: 190,
                        minWidth: 190,
                        borderRight: isScrolled
                          ? '1px solid rgba(0,0,0,0.8)'
                          : 'none',
                        boxShadow: isScrolled
                          ? '6px 0 10px rgba(0,0,0,0.15)'
                          : 'none',
                        transition: 'border-right 0.2s, box-shadow 0.2s'
                      }}
                    >
                      <Box display="flex" flexDirection="column">
                        <Tooltip
                          title={
                            order.end_user?.full_name ||
                            order.agency?.name ||
                            order.customer_name ||
                            '--'
                          }
                          arrow
                          placement="top-start"
                        >
                          <Typography
                            className={classes.customerName}
                            style={{
                              color:
                                order.customer_type === 'AGENCY'
                                  ? '#3f51b5'
                                  : '#1a1f36',
                              whiteSpace: 'normal'
                            }}
                          >
                            {order.end_user?.full_name ||
                              order.agency?.name ||
                              order.customer_name ||
                              '--'}
                          </Typography>
                        </Tooltip>
                        <Typography
                          variant="body2"
                          style={{ fontSize: 13, color: '#888' }}
                        >
                          {order.end_user?.phone ||
                            (order.customer_type === 'AGENCY'
                              ? order.agency?.leader?.phone ||
                                order.agency?.phone
                              : '') ||
                            '--'}
                        </Typography>
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell style={{ minWidth: 220 }}>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        style={{ fontSize: 13, whiteSpace: 'normal' }}
                      >
                        {order.end_user?.address ||
                          order.agency?.leader?.address ||
                          order.agency_name ||
                          '--'}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell style={{ minWidth: 150 }}>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        style={{ fontSize: 13, whiteSpace: 'normal' }}
                      >
                        {order.description || '--'}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{ gap: 6, maxWidth: 220 }}
                      >
                        {(
                          order.order_device_types ||
                          order.devices ||
                          []
                        ).map((d, i) => {
                          const typeName =
                            d.device_type?.name ||
                            d.device_type_name ||
                            d.type ||
                            listDeviceType.find(
                              lt => lt.id === d.device_type_id
                            )?.name ||
                            'N/A';
                          return (
                            <Chip
                              key={i}
                              size="small"
                              label={`${d.quantity} x ${typeName}`}
                              style={{
                                background: '#e8f0fe',
                                color: '#1a73e8',
                                fontWeight: 600,
                                fontSize: 11,
                                height: 20
                              }}
                            />
                          );
                        })}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Button
                        size="small"
                        variant="outlined"
                        disabled={isSale || order.status === -1}
                        onClick={() => {
                          setEditingOrder(order);
                          const initialDevices = (
                            order.order_device_types ||
                            order.devices ||
                            []
                          ).map(odt => ({
                            ...JSON.parse(JSON.stringify(odt)),
                            device_type_name:
                              odt.device_type?.name ||
                              odt.device_type_name ||
                              odt.type ||
                              listDeviceType.find(
                                lt => lt.id === odt.device_type_id
                              )?.name ||
                              'N/A',
                            device_ids:
                              odt.order_details?.map(od => od.device_id) ||
                              [],
                            serials:
                              odt.order_details?.map(
                                od =>
                                  od.serial ||
                                  od.device?.serial ||
                                  od.device?.imei
                              ) || []
                          }));
                          setEditingDevices(initialDevices);
                        }}
                        style={{
                          height: 24,
                          fontSize: 11,
                          textTransform: 'none',
                          background:
                            order.status >= 3 ||
                            (
                              order.order_device_types || order.devices
                            )?.every(
                              d =>
                                (d.order_details || d.serials)?.length >=
                                d.quantity
                            )
                              ? 'transparent'
                              : '#eaf4fb',
                          borderColor:
                            order.status >= 3 ||
                            (
                              order.order_device_types || order.devices
                            )?.every(
                              d =>
                                (d.order_details || d.serials)?.length >=
                                d.quantity
                            )
                              ? '#3f51b560'
                              : '#2980b9',
                          color:
                            order.status >= 3 ||
                            (
                              order.order_device_types || order.devices
                            )?.every(
                              d =>
                                (d.order_details || d.serials)?.length >=
                                d.quantity
                            )
                              ? '#3f51b5'
                              : '#2980b9'
                        }}
                      >
                        {order.status >= 3 ||
                        (order.order_device_types || order.devices)?.every(
                          d =>
                            (d.order_details || d.serials)?.length >=
                            d.quantity
                        )
                          ? 'Xem Serial'
                          : '+ Thêm Serial'}
                      </Button>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Box display="flex" flexDirection="column">
                        <Typography
                          variant="body2"
                          style={{
                            fontSize: 13,
                            color: '#333',
                            fontWeight: 600
                          }}
                        >
                          {(order.sim_method || order.simMethod || '--')
                            .replace(/Vgps/g, 'VGPS')
                            .split('(')[0]
                            .trim()}
                        </Typography>
                        {(order.sim_method || order.simMethod || '').includes(
                          '('
                        ) && (
                          <Typography
                            variant="body2"
                            style={{ fontSize: 12, color: '#666' }}
                          >
                            {
                              (order.sim_method || order.simMethod).match(
                                /\(([^)]+)\)/
                              )?.[1]
                            }
                          </Typography>
                        )}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography
                        variant="body2"
                        style={{ fontSize: 13, color: '#333' }}
                      >
                        {(order.active_method || order.activeMethod || '--').replace(/Vgps/g, 'VGPS')}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography
                        variant="body2"
                        style={{ fontSize: 13, color: '#333' }}
                      >
                        {(order.buy_method || order.buyMethod || '--').replace(/Vgps/g, 'VGPS')}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography
                        variant="body2"
                        style={{ fontSize: 13, color: '#333' }}
                      >
                        {(order.installer || '--').replace(/Vgps/g, 'VGPS')}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Tooltip title="Tải ảnh lắp đặt">
                        <IconButton
                          size="small"
                          onClick={() => {
                            setOrderForImage(order);
                            setOpenImageModal(true);
                          }}
                          disabled={
                            isSale ||
                            order.status >= 4 ||
                            order.status === -1
                          }
                          style={{
                            color:
                              isSale || order.status >= 4
                                ? '#ccc'
                                : '#1a73e8'
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Box
                        display="flex"
                        style={{ gap: 4, alignItems: 'center' }}
                      >
                        {(order.order_images || [])
                          .slice(0, 2)
                          .map((img, i) => (
                            <Box
                              key={i}
                              onClick={() =>
                                setSelectedGallery({
                                  images: order.order_images,
                                  index: i,
                                  orderId: order.id,
                                  order_status: order.status
                                })
                              }
                              style={{
                                width: 32,
                                height: 32,
                                borderRadius: 4,
                                overflow: 'hidden',
                                cursor: 'pointer',
                                border: '1px solid #eee'
                              }}
                            >
                              <img
                                src={`${process.env.REACT_APP_IMG_SERVER}/${img.url}`}
                                alt="order"
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover'
                                }}
                              />
                            </Box>
                          ))}
                        {(order.order_images || []).length > 2 && (
                          <Typography
                            variant="caption"
                            style={{
                              color: '#3f51b5',
                              fontWeight: 600,
                              cursor: 'pointer'
                            }}
                            onClick={() =>
                              setSelectedGallery({
                                images: order.order_images,
                                index: 2,
                                orderId: order.id,
                                order_status: order.status
                              })
                            }
                          >
                            +{(order.order_images || []).length - 2}
                          </Typography>
                        )}
                        {(order.order_images || []).length === 0 && '--'}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Box>
                        <Typography
                          style={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#1a1f36'
                          }}
                        >
                          {formatMoney(
                            (order.total_amount || order.totalAmount || 0) -
                              (order.extra_fee || 0)
                          )}
                        </Typography>
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>
                      <TextField
                        size="small"
                        placeholder="0"
                        disabled={
                          !(isAdmin || isAccountant) ||
                          order.status === 4 ||
                          order.status === -1
                        }
                        value={
                          localExtraFees[order.id] !== undefined
                            ? localExtraFees[order.id]
                            : formatInputMoney(order.extra_fee || 0)
                        }
                        onChange={e =>
                          setLocalExtraFees({
                            ...localExtraFees,
                            [order.id]: e.target.value
                          })
                        }
                        onFocus={e => {
                          if (localExtraFees[order.id] === undefined) {
                            setLocalExtraFees({
                              ...localExtraFees,
                              [order.id]: formatInputMoney(
                                order.extra_fee || 0
                              )
                            });
                          }
                        }}
                        onBlur={() => handleSaveExtraFee(order)}
                        variant="outlined"
                        InputProps={{
                          style: { fontSize: 12, height: 32, width: 130 },
                          endAdornment: (
                            <Typography
                              style={{
                                fontSize: 10,
                                color: '#888',
                                whiteSpace: 'nowrap',
                                marginLeft: 2
                              }}
                            >
                              đ
                            </Typography>
                          )
                        }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <Box>
                        <Typography
                          style={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#e67e22'
                          }}
                        >
                          {formatMoney(
                            order.total_amount || order.totalAmount || 0
                          )}
                        </Typography>
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>
                      {(() => {
                        const method =
                          order.payment_method || order.paymentMethod;
                        const style = getPaymentStyle(method);
                        return (
                          <Typography
                            variant="body2"
                            style={{
                              fontSize: 11,
                              fontWeight: 700,
                              color: style.color,
                              background: style.bg,
                              padding: '4px 10px',
                              borderRadius: 12,
                              display: 'inline-block',
                              border: `1px solid ${style.color}22`
                            }}
                          >
                            {method || '--'}
                          </Typography>
                        );
                      })()}
                    </StyledTableCell>
                    <StyledTableCell>
                      <Tooltip
                        title={
                          order.status < 1
                            ? 'Cần nhập Serial thiết bị trước'
                            : ''
                        }
                      >
                        <span>
                          <TextField
                            size="small"
                            placeholder="Dán link vận đơn..."
                            disabled={
                              order.status < 1 ||
                              order.status >= 4 ||
                              isSale ||
                              order.delivery_method === 0 ||
                              order.installer?.replace(/Vgps/g, 'VGPS') === 'VGPS lắp đặt'
                            }
                            value={
                              localTrackingUrls[order.id] !== undefined
                                ? localTrackingUrls[order.id]
                                : order.delivery_method === 0 ||
                                     order.installer?.replace(/Vgps/g, 'VGPS') === 'VGPS lắp đặt'
                                ? 'offline'
                                : order.tracking_number || ''
                            }
                            onChange={e =>
                              setLocalTrackingUrls({
                                ...localTrackingUrls,
                                [order.id]: e.target.value
                              })
                            }
                            onBlur={() => handleSaveTrackingUrl(order)}
                            variant="outlined"
                            InputProps={{
                              style: {
                                fontSize: 11,
                                height: 32,
                                width: 180
                              },
                              endAdornment:
                                order.tracking_number ||
                                localTrackingUrls[order.id] ? (
                                  <InputAdornment position="end">
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        let url = order.tracking_number || localTrackingUrls[order.id];
                                        if (url && !/^https?:\/\//i.test(url)) {
                                          url = 'http://' + url;
                                        }
                                        window.open(url, '_blank');
                                      }}
                                    >
                                      <OpenInNewIcon
                                        style={{ fontSize: 16 }}
                                      />
                                    </IconButton>
                                  </InputAdornment>
                                ) : null
                            }}
                          />
                        </span>
                      </Tooltip>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Tooltip
                        title={
                          order.status < 2
                            ? 'Cần nhập link vận đơn trước'
                            : order.status >= 3
                            ? 'Đã giao hàng'
                            : ''
                        }
                      >
                        <span>
                          <Checkbox
                            size="small"
                            color="primary"
                            disabled={
                              order.status < 2 ||
                              order.status >= 4 ||
                              isSale
                            }
                            checked={order.status >= 3}
                            onChange={e =>
                              handleDeliveredToggle(order, e.target.checked)
                            }
                          />
                        </span>
                      </Tooltip>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Tooltip title="Hoàn thành đơn">
                        <IconButton
                          size="small"
                          disabled={
                            order.status < 3 ||
                            order.status >= 4 ||
                            !(isAdmin || isAccountant)
                          }
                          onClick={() => handleCompleteOrder(order)}
                          style={{
                            color:
                              order.status < 3 || order.status >= 4
                                ? '#ccc'
                                : '#27ae60'
                          }}
                        >
                          <CheckCircleIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Chip
                        label={cfg.label}
                        size="small"
                        style={{
                          background: cfg.bg,
                          color: cfg.color,
                          fontWeight: 700,
                          fontSize: 11,
                          border: `1px solid ${cfg.color}33`
                        }}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <IconButton
                        size="small"
                        onClick={e => handleMenuOpen(e, order)}
                      >
                        <MoreVertIcon fontSize="small" />
                      </IconButton>
                    </StyledTableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={23} align="center" style={{ padding: 40 }}>
                  <Typography variant="body1" color="textSecondary">
                    Không tìm thấy dữ liệu đơn hàng...
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Box>

      {paginated && paginated.length > 0 && (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          style={{ width: '100%' }}
          p={2}
          borderTop="1px solid #eee"
        >
          <Box display="flex" style={{ gap: 12 }}>
            <Box
              style={{
                border: '1px solid #3f51b5',
                borderRadius: 8,
                padding: '4px 12px',
                background: '#f5f6ff',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography
                style={{ fontSize: 13, color: '#3f51b5', fontWeight: 700 }}
              >
                Tổng tiền: {formatMoney(totalAmountSum)}
              </Typography>
            </Box>
            <Box
              style={{
                border: '1px solid #27ae60',
                borderRadius: 8,
                padding: '4px 12px',
                background: '#eafaf1',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography
                style={{ fontSize: 13, color: '#27ae60', fontWeight: 700 }}
              >
                Đã trả: {formatMoney(totalPaidSum)}
              </Typography>
            </Box>
          </Box>

          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Typography style={{ fontSize: '14px' }}>
              Tổng: {total || 0}
            </Typography>
            <Pagination
              count={Math.ceil((total || 0) / PAGE_SIZE)}
              color="primary"
              size="small"
              onChange={(_, p) => setPage(p)}
              page={page}
              siblingCount={1}
              boundaryCount={2}
              showFirstButton
              showLastButton
            />
          </Box>
        </Box>
      )}
    </Card>
  );
};

export default OrdersTable;
